/*
 * Charli Baby – «Suche wie 4mybaby» (02.11.2026), «Kategorien wie Suche» (02.11.2026)
 * Eine App für die Such-Ebene (alle Seiten, sections/cb-suche-ebene.liquid), die Suchseite
 * (/search, sections/cb-suche-seite.liquid) und die Kategorieseiten (sections/cb-kollektion.liquid).
 * - Daten: sections/cb-suche-daten.liquid liefert bis 250 Treffer als JSON (Section Rendering API);
 *   Kategorien: die ersten 250 Produkte stehen in der Seite, weitere liefert sections/cb-kollektion-daten.liquid.
 * - Gleiche Modelle in verschiedenen Farben = eine Karte mit Farb-Musterbildern
 *   (Titel ohne Farbwörter und ohne Werte der ersten Option verglichen). Ein Produkt mit Farb-Varianten
 *   zeigt die Varianten als Musterbilder (Bild, Preis und Lagerstand je Farbe).
 * - «Zur passenden Kategorie», Filter (Marke, Kategorie, Verfügbarkeit, Preis), Sortierung,
 *   «Aktuelle Highlights» vor der Eingabe. Texte Deutsch/Französisch unten in TEXTE.
 */
(() => {
  'use strict';
  if (window.cbSuche) return;
  const API = (window.cbSuche = {});
  const LIMIT = 24;

  const TEXTE = {
    de: {
      platzhalter: 'Wonach suchst du?',
      suchen: 'Suchen',
      leeren: 'Eingabe löschen',
      schliessen: 'Suche schliessen',
      filterZu: 'Filter schliessen',
      passendeKat: 'Zur passenden Kategorie',
      beliebteKat: 'Beliebte Kategorien',
      highlights: 'Aktuelle Highlights',
      alleHighlights: 'Alle Aktionen ansehen',
      filter: 'Filter',
      sortieren: 'Sortieren nach',
      setTitel: 'Set-Typ',
      setTypen: { alle: 'Alle', '2in1': '2in1 Sets', '3in1': '3in1 Sets', '4in1': '4in1 Sets', '5in1': '5in1 Sets', '9t': '9-teilige Sets', '12t': '12-teilige Sets', '13t': '13-teilige Sets', nur: 'Nur Kinderwagen' },
      sort: {
        relevanz: 'Relevanz',
        empfohlen: 'Empfohlen',
        'preis-auf': 'Tiefster Preis',
        'preis-ab': 'Höchster Preis',
        'name-az': 'Name (A bis Z)',
        'name-za': 'Name (Z bis A)',
      },
      anzahl1: '1 Suchergebnis gefunden',
      anzahlN: '{n} Suchergebnisse gefunden',
      produkt1: '1 Produkt',
      produktN: '{n} Produkte',
      leerKat: 'In dieser Kategorie gibt es gerade keine Produkte.',
      zurSuche: 'Zur Suche',
      mehrAls: 'Es gibt noch mehr Treffer – gib einen genaueren Suchbegriff ein.',
      keine: 'Für «{q}» haben wir leider nichts gefunden.',
      keineTipp: 'Prüfe die Schreibweise oder versuche einen allgemeineren Begriff, z. B. «Kinderwagen» oder eine Marke.',
      keineFilter: 'Keine Produkte passen zu diesen Filtern.',
      filterLoeschen: 'Alle Filter löschen',
      laedt: 'Suche läuft …',
      fehler: 'Die Suche ist gerade nicht erreichbar. Bitte versuche es gleich nochmals.',
      erneut: 'Nochmals versuchen',
      mehr: 'Weitere Produkte anzeigen',
      farbe: 'Farbe',
      alleFarben: 'Alle Farben zeigen',
      anLager: 'An Lager',
      ausverkauft: 'Ausverkauft',
      vorbestellbar: 'Vorbestellbar – mit Lieferzeit',
      ab: 'ab',
      statt: 'statt',
      marke: 'Marke',
      kategorie: 'Kategorie',
      katSuchen: 'Kategorie suchen',
      verfuegbarkeit: 'Verfügbarkeit',
      nurLager: 'Nur an Lager',
      preis: 'Preis (CHF)',
      von: 'von',
      bis: 'bis',
      zuruecksetzen: 'Zurücksetzen',
      anzeigen: 'Ergebnisse anzeigen ({n})',
      seitentitel: 'Suche',
      entfernen: 'Filter entfernen: {x}',
    },
    fr: {
      platzhalter: 'Que cherches-tu ?',
      suchen: 'Rechercher',
      leeren: 'Effacer',
      schliessen: 'Fermer la recherche',
      filterZu: 'Fermer les filtres',
      passendeKat: 'Catégories correspondantes',
      beliebteKat: 'Catégories populaires',
      highlights: 'Coups de cœur du moment',
      alleHighlights: 'Voir toutes les promotions',
      filter: 'Filtres',
      sortieren: 'Trier par',
      setTitel: "Type d'ensemble",
      setTypen: { alle: 'Tous', '2in1': 'Ensembles 2 en 1', '3in1': 'Ensembles 3 en 1', '4in1': 'Ensembles 4 en 1', '5in1': 'Ensembles 5 en 1', '9t': 'Ensembles 9 pièces', '12t': 'Ensembles 12 pièces', '13t': 'Ensembles 13 pièces', nur: 'Poussette seule' },
      sort: {
        relevanz: 'Pertinence',
        empfohlen: 'Recommandés',
        'preis-auf': 'Prix le plus bas',
        'preis-ab': 'Prix le plus élevé',
        'name-az': 'Nom (A à Z)',
        'name-za': 'Nom (Z à A)',
      },
      anzahl1: '1 résultat trouvé',
      anzahlN: '{n} résultats trouvés',
      produkt1: '1 produit',
      produktN: '{n} produits',
      leerKat: 'Il n’y a actuellement aucun produit dans cette catégorie.',
      zurSuche: 'Vers la recherche',
      mehrAls: 'Il y a encore plus de résultats – précise ta recherche.',
      keine: 'Aucun résultat pour «{q}».',
      keineTipp: 'Vérifie l’orthographe ou essaie un terme plus général, p. ex. «poussette» ou une marque.',
      keineFilter: 'Aucun produit ne correspond à ces filtres.',
      filterLoeschen: 'Effacer tous les filtres',
      laedt: 'Recherche en cours …',
      fehler: 'La recherche n’est pas disponible pour le moment. Réessaie dans un instant.',
      erneut: 'Réessayer',
      mehr: 'Afficher plus de produits',
      farbe: 'Couleur',
      alleFarben: 'Afficher toutes les couleurs',
      anLager: 'En stock',
      ausverkauft: 'Épuisé',
      vorbestellbar: 'Précommande – avec délai de livraison',
      ab: 'dès',
      statt: 'au lieu de',
      marke: 'Marque',
      kategorie: 'Catégorie',
      katSuchen: 'Rechercher une catégorie',
      verfuegbarkeit: 'Disponibilité',
      nurLager: 'Uniquement en stock',
      preis: 'Prix (CHF)',
      von: 'de',
      bis: 'à',
      zuruecksetzen: 'Réinitialiser',
      anzeigen: 'Afficher les résultats ({n})',
      seitentitel: 'Recherche',
      entfernen: 'Retirer le filtre : {x}',
    },
  };

  // Farbwörter, die in Titeln vorkommen (zusätzlich zu den Werten der ersten Option jedes Produkts)
  const FARBEN = ['moon black', 'dune grey', 'tiny sheep', 'almond beige', 'chocolate brown', 'stormy blue', 'moss green', 'seashell beige', 'stone grey', 'navy blue', 'ocean blue', 'magic black', 'sepia black', 'cozy beige', 'mirage grey', 'peach pink', 'nautical blue', 'city grey', 'off white', 'sage green', 'coconut brown', 'urban mobility black', 'urban mobility white', 'royal blue', 'thunder grey', 'grey flannel', 'honey ash', 'natural ash', 'deep green', 'crepe beige', 'mineral grey', 'olive-green', 'midnight black', 'dark grey', 'light grey', 'light oat', 'pale pink', 'sky green', 'chalk brown', 'beech wood', 'muted terra', 'arctic silver', 'fog grey', 'lava grey', 'candy pink', 'powdery pink', 'sky blue', 'beach blue', 'hibiscus red', 'nature green', 'misty grey', 'opal blue', 'quartz pink', 'amber brown', 'jade green', 'iconic black', 'pure black', 'white copper', 'white silver', 'white rose', 'black', 'schwarz', 'white', 'weiss', 'weiß', 'grey', 'gray', 'grau', 'beige', 'blue', 'blau', 'pink', 'rosa', 'rose', 'green', 'grün', 'gelb', 'olive', 'braun', 'brown', 'taupe', 'ecru', 'nature', 'vintage', 'graphite', 'champagner', 'cream', 'clay', 'walnut', 'chestnut', 'caviar', 'biscotti', 'cedar', 'chateau', 'pistachio', 'thunder', 'cosmopolitan', 'granite', 'riveted', 'forest', 'calla', 'seasalt', 'sanderson', 'heritage', 'cocoa', 'pearl', 'quarz', 'dusk', 'eclipse', 'ebony', 'evergreen', 'sandstone', 'shale', 'oak', 'pebble', 'midnight', 'ash', 'heather', 'frappe', 'frappé', 'espresso', 'ganache', 'mint', 'snowflake', 'purple', 'graphene', 'mica', 'elemente', 'hellbeige', 'hellgrün', 'champagne gold', 'rosegold', 'chrome', 'matt black', 'noir', 'blanc', 'gris', 'bleu', 'vert', 'marron', 'brun', 'jaune', 'naturel', 'crème', 'anthracite', 'milky', 'woody', 'granti', 'gato', 'browny', 'lungo', 'frossy', 'yuki', 'hellrosa', 'darkbeige', 'kastanie', 'cashmere', 'stone', 'coral', 'thyme', 'leaf', 'blossom', 'stripes', 'sheep', 'bison', 'flora', 'mermaid', 'schokolade', 'raven', 'cashew', 'almond', 'noir lune', 'beige amande', 'amande beige', 'bleu orageux', 'bleu orage', 'gris pierre', 'vert mousse', 'chocolat', 'émeraude', 'ébène', 'éclipse', 'grès', 'toffee', 'peacock', 'sage', 'rosemary', 'mushroom', 'sky', 'elderberry', 'vanille', 'vanilla', 'karamell', 'caramel', 'muna'];
  // Modellnamen mit einem Farbwort darin (z. B. «Nuna Leaf»): dort zählt das Wort nicht als Farbe
  const SCHUTZ = ['nuna leaf', 'leaf grow'];

  const ICON = {
    zurueck: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    lupe: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    x: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    xKlein: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    filter: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 6h11M18 6h3M3 12h5M12 12h9M3 18h13M20 18h1"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    runter: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    uhr: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const escRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const fmt = (t, o) => t.replace(/\{(\w+)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const norm = (s) => s.toLowerCase().replace(/[™®️•°'’"«»()]/g, ' ').replace(/\s[–—-]\s/g, ' ').replace(/\s+/g, ' ').trim();
  const klein = (url, w) => (url ? url.replace(/([?&])width=\d+/, `$1width=${w}`) : '');
  // Produkt-Adresse mit gewählter Variante (?variant=…), Such-Zusätze wie _pos bleiben erhalten
  const mitVariante = (u, id) => {
    if (!id) return u;
    const [pfad, rest = ''] = String(u || '').split('?');
    const teile = rest.split('&').filter((x) => x && !/^variant=/.test(x));
    teile.push(`variant=${id}`);
    return `${pfad}?${teile.join('&')}`;
  };
  // Enthält der Titel alle Suchwörter (ab 3 Zeichen, Bindestriche egal: 7in1 = 7-in-1)? Ohne solche Wörter passt jeder Titel.
  const titelPasst = (q) => {
    const ohne = (s) => norm(s).replace(/-/g, '');
    const woerter = ohne(q || '').split(' ').filter((w) => w.length > 2);
    return (p) => {
      const t = ohne(p.t);
      return woerter.every((w) => t.includes(w));
    };
  };
  const RX = new Map();
  const rx = (w) => {
    let r = RX.get(w);
    if (!r) {
      r = new RegExp(`(^|[\\s\\-–—'(/])${escRe(w)}(?=$|[\\s\\-–—'),./])`, 'gi');
      RX.set(w, r);
    }
    return r;
  };

  // Titel zerlegen: Farbe(n) heraus, Rest = Modell. key fasst Farben desselben Modells zusammen.
  // griff = Handle ohne Farbwörter (in allen Sprachen gleich, auch wenn die Titel verschieden übersetzt sind)
  const zerlegen = (p) => {
    if (p._z) return p._z;
    const eigene = (p.o || []).map((x) => String(x).toLowerCase().trim()).filter((x) => x.length > 1);
    const liste = Array.from(new Set(eigene.concat(FARBEN))).sort((a, b) => b.length - a.length);
    let rest = ` ${p.t} `;
    const teile = [];
    const tn = ` ${norm(p.t)} `;
    const geschuetzt = SCHUTZ.filter((s) => tn.includes(` ${s} `)).map((s) => ` ${s} `);
    for (const w of liste) {
      if (geschuetzt.length && geschuetzt.some((s) => s.includes(` ${w} `))) continue;
      const re = rx(w);
      re.lastIndex = 0;
      if (!re.test(rest)) continue;
      re.lastIndex = 0;
      rest = rest.replace(re, (m, vor) => {
        teile.push(m.slice(vor.length).trim());
        return `${vor} `;
      });
    }
    let sauber = rest.replace(/\(\s*\)/g, ' ').replace(/\s+/g, ' ').trim();
    sauber = sauber
      .replace(/\s+(in|en)(?=\s*(?:$|inkl|incl|\+|–|—|-|,))/gi, '')
      .replace(/[\s\-–—,+/]+$/, '')
      .replace(/^[\s\-–—,+/]+/, '')
      .trim();
    const marke = (p._marke || '').trim();
    // Einzelkarte (Tag «einzeln»): voller Titel mit Farbe, sonst Titel ohne Farbwörter
    let modell = p.e ? p.t : sauber;
    for (const vor of [marke, p.v || '']) {
      if (vor && modell.toLowerCase().startsWith(`${vor.toLowerCase()} `)) {
        modell = modell.slice(vor.length + 1);
        break;
      }
    }
    if (!modell) modell = p.t;
    let griff = `-${String(p.u || '').replace(/^.*\/products\//, '').replace(/[?#].*$/, '').toLowerCase()}-`;
    let griffFarbe = false;
    for (const w of liste) {
      const wh = w.replace(/\s+/g, '-');
      if (!griff.includes(`-${wh}-`)) continue;
      if (geschuetzt.some((s) => s.includes(` ${w} `))) continue;
      griffFarbe = true;
      // Farbwort weg, auch eine direkt folgende Nummer (doppelter Handle wie «…-evergreen-1»)
      griff = griff.replace(new RegExp(`-${escRe(wh)}(?:-\\d{1,2})?(?=-)`, 'g'), '');
    }
    // Tag «einzeln» (JSON e:true): eigene Karte, keine Zusammenfassung mit anderen Farben.
    // Tag «einzeln-muster» (e:2) bleibt in der Modell-Gruppe; gruppieren() macht daraus je Produkt eine eigene Karte.
    const allein = p.e === true;
    p._z = {
      key: allein ? `${marke.toLowerCase()}|#${p.i}` : `${marke.toLowerCase()}|${norm(sauber || p.t)}`,
      griff: !allein && griffFarbe && griff.length > 2 ? `${marke.toLowerCase()}#${griff}` : '',
      modell,
      farbe: teile.join(' / '),
    };
    return p._z;
  };

  const gruppieren = (liste, wahl) => {
    const map = new Map();
    let gruppen = [];
    for (const p of liste) {
      const z = zerlegen(p);
      let g = map.get(z.key);
      if (!g) {
        g = { key: z.key, modell: z.modell, marke: p._marke || '', glieder: [], rang: p._rang };
        map.set(z.key, g);
        gruppen.push(g);
      }
      g.glieder.push(p);
    }
    // Karten mit gleichem Handle-Kern zusammenführen (übersetzte Titel sind oft verschieden, der Handle nicht).
    // Je Karte zählt der Handle-Kern der Mehrheit ihrer Produkte, so verbindet ein einzelner falscher Handle nichts.
    const haupt = (g) => {
      const n = new Map();
      g.glieder.forEach((p) => {
        const gr = zerlegen(p).griff;
        if (gr) n.set(gr, (n.get(gr) || 0) + 1);
      });
      let best = '';
      let max = 0;
      n.forEach((v, k) => {
        if (v > max) {
          best = k;
          max = v;
        }
      });
      return max * 2 > g.glieder.length ? best : '';
    };
    const nachGriff = new Map();
    const weg = new Set();
    gruppen.forEach((g) => {
      const gr = haupt(g);
      if (!gr) return;
      const ziel = nachGriff.get(gr);
      if (!ziel) {
        nachGriff.set(gr, g);
        return;
      }
      ziel.glieder.push(...g.glieder);
      weg.add(g);
    });
    if (weg.size) gruppen = gruppen.filter((g) => !weg.has(g));
    const besser = (a, b) => (a.l !== b.l ? a.l : a.a !== b.a ? a.a : a._rang < b._rang);
    for (const g of gruppen) {
      if (g.glieder.length > 1) {
        const je = new Map();
        for (const p of g.glieder) {
          const f = norm(zerlegen(p).farbe || p.t);
          const da = je.get(f);
          if (!da || besser(p, da)) je.set(f, p);
        }
        if (je.size < g.glieder.length) {
          const bleiben = new Set(je.values());
          g.glieder = g.glieder.filter((p) => bleiben.has(p));
        }
      }
      const gewaehlt = wahl && wahl[g.key];
      let i = gewaehlt ? g.glieder.findIndex((p) => p.i === gewaehlt) : -1;
      if (i < 0) i = g.glieder.findIndex((p) => p.l);
      if (i < 0) i = g.glieder.findIndex(lagerP);
      if (i < 0) i = g.glieder.findIndex((p) => p.a);
      g.aktiv = i < 0 ? 0 : i;
      // Ein einzelnes Produkt mit Farb-Varianten: Musterbilder = Varianten (zuerst eine Farbe an Lager)
      g.var = null;
      g.vAktiv = 0;
      g.vGewaehlt = false;
      if (g.glieder.length === 1) {
        const p = g.glieder[0];
        if (Array.isArray(p.vs) && p.vs.length > 1) {
          g.var = p.vs;
          const vw = wahl && wahl[`${g.key}#v`];
          let j = vw ? p.vs.findIndex((v) => v.i === vw) : -1;
          g.vGewaehlt = j >= 0;
          if (j < 0) j = p.vs.findIndex((v) => v.l);
          if (j < 0) j = p.vs.findIndex((v) => v.i === p.vi && v.a);
          if (j < 0) j = p.vs.findIndex((v) => v.a);
          if (j < 0) j = p.vs.findIndex((v) => v.i === p.vi);
          g.vAktiv = j < 0 ? 0 : j;
        }
      }
    }
    // Tag «einzeln-muster» (03.11.2026, Priam/e-Priam): je Produkt eine eigene Karte mit eigenem Titel (inkl. Farbe) und Bild,
    // die Musterbilder zeigen alle Farben des Modells. Ein Produkt mit Farb-Varianten: je Variante eine eigene Karte.
    if (!gruppen.some((g) => g.glieder.some((p) => p.e === 2))) return gruppen;
    const karten = [];
    for (const g of gruppen) {
      if (!g.glieder.some((p) => p.e === 2)) {
        karten.push(g);
        continue;
      }
      if (g.var) {
        const p = g.glieder[0];
        g.var.forEach((v, j) => {
          const key = `${g.key}#v${v.i}`;
          const vw = wahl && wahl[`${key}#v`];
          const k = vw ? g.var.findIndex((x) => x.i === vw) : -1;
          karten.push({ key, modell: g.modell, marke: g.marke, glieder: g.glieder, rang: p._rang + j / 1000, aktiv: 0, var: g.var, vAktiv: k < 0 ? j : k, vGewaehlt: true, eigen: p, eigenV: v });
        });
        continue;
      }
      g.glieder.forEach((p, i) => {
        const key = `${g.key}#${p.i}`;
        const gw = wahl && wahl[key];
        const a = gw ? g.glieder.findIndex((x) => x.i === gw) : -1;
        karten.push({ key, modell: zerlegen(p).modell, marke: g.marke, glieder: g.glieder, rang: p._rang, aktiv: a < 0 ? i : a, var: null, vAktiv: 0, vGewaehlt: false, eigen: p });
      });
    }
    return karten;
  };
  // An Lager / kaufbar über alle Farb-Varianten (für Filter und Reihenfolge)
  const lagerP = (p) => (p._l != null ? p._l : !!p.l);
  const kaufbarP = (p) => (p._a != null ? p._a : !!p.a);
  // Einzelkarten (Tag «einzeln-muster»): Lager, Filter und Kategorien zählen nur das eigene Produkt bzw. die eigene Farbe
  const kartenTeile = (g) => (g.eigen ? [g.eigen] : g.glieder);
  const kartenLager = (g) => (g.eigenV ? !!g.eigenV.l : kartenTeile(g).some(lagerP));
  const kartenKaufbar = (g) => (g.eigenV ? !!g.eigenV.a : kartenTeile(g).some(kaufbarP));
  // Farbe in einen Titel einsetzen: vor dem ersten « – » (Modell – Beschreibung), sonst hinten
  const mitFarbe = (t, f) => {
    if (!f) return t;
    const i = t.indexOf(' – ');
    return i > 0 ? `${t.slice(0, i)} ${f}${t.slice(i)}` : `${t} – ${f}`;
  };

  // Marke: erste Marken-Sammlung aus dem Menü «Marken» (der Hersteller ist oft «Charli Baby»), sonst Hersteller
  const vorbereiten = (d) => {
    d.p = Array.isArray(d.p) ? d.p : [];
    d.kat = d.kat || {};
    d.marken = d.marken || {};
    d.p.forEach((p, i) => {
      p._rang = i;
      const h = (p.m || '').split('|').find((x) => x && d.marken[x]);
      p._marke = h ? d.marken[h].t : p.v || '';
      if (Array.isArray(p.vs) && p.vs.length > 1) {
        p.vs = p.vs.filter((v) => v && v.i);
        p._l = !!p.l || p.vs.some((v) => v.l);
        p._a = !!p.a || p.vs.some((v) => v.a);
      }
    });
    return d;
  };
  const lesen = (html) => {
    const m = html.match(/<script[^>]*data-cb-suche-daten[^>]*>([\s\S]*?)<\/script>/);
    if (!m) throw new Error('Keine Suchdaten');
    return vorbereiten(JSON.parse(m[1]));
  };
  const neuerFilter = () => ({ marke: new Set(), kat: new Set(), lager: false, von: null, bis: null, set: '' });
  // Set-Typen (03.11.2026): Kacheln über dem Raster einer Kategorie, z. B. «Nuna MIXX next» → 4in1 / 3in1 / 2in1 / Nur Kinderwagen.
  // Schlüssel «st» je Produkt aus snippets/cb-suche-produkt.liquid («4in1|»). Auf den Set-Typ-Seiten selbst gibt es keine Kacheln.
  const SET_TYPEN = ['4in1', '3in1', '2in1', '5in1', '9t', '12t', '13t', 'nur'];
  const SET_OHNE = new Set(['bundle-full-sets', '2in1-kinderwagen-sets', '3in1-kinderwagen-sets', '4in1-kinderwagen-sets', '5in1-kinderwagen-sets', '9-teilige-kinderwagen-sets', '12-teilige-kinderwagen-sets', '13-teilige-kinderwagen-sets', 'nur-kinderwagen']);
  const setHat = (p, s) => `|${p.st || ''}`.indexOf(`|${s}|`) >= 0;

  class App {
    constructor(root, modus) {
      this.root = root;
      this.modus = modus;
      this.sprache = (root.dataset.sprache || document.documentElement.lang || 'de').slice(0, 2) === 'fr' ? 'fr' : 'de';
      this.t = TEXTE[this.sprache];
      this.basis = `${(root.dataset.root || '/').replace(/\/$/, '')}/`;
      this.highlights = root.dataset.highlights || '';
      this.kollektion = root.dataset.kollektion || '';
      this.lagerZuerst = root.dataset.lagerZuerst !== 'false';
      this.schritt = Math.max(4, parseInt(root.dataset.start, 10) || LIMIT);
      this.sortListe = modus === 'kollektion' ? ['empfohlen', 'preis-auf', 'preis-ab', 'name-az', 'name-za'] : ['relevanz', 'preis-auf', 'preis-ab', 'name-az', 'name-za'];
      this.q = '';
      this.daten = null;
      this.datenVersion = 0;
      this.startDaten = null;
      this.f = neuerFilter();
      this.sort = this.sortListe[0];
      this.limit = this.schritt;
      this.wahl = {};
      this.offeneFarben = {};
      this.cache = new Map();
      this.gruppenMap = {};
      this.katSuche = '';
      this.stabil = null;
      this.angezeigt = [];
      this.laedtNoch = false;
      this.zielY = null;
      let start = null;
      const json = root.querySelector('script[data-cb-suche-daten]');
      if (json) {
        try {
          start = vorbereiten(JSON.parse(json.textContent));
        } catch (e) {
          start = null;
        }
      }
      this.bauen();
      this.binden();
      if (modus === 'kollektion') {
        this.daten = start || vorbereiten({ p: [], seite: 0 });
        this.kollektionStarten();
      } else if (modus === 'seite') {
        if (start && start.q) {
          this.eingabe.value = start.q;
          this.q = start.q;
          this.daten = start;
          this.cache.set(start.q.trim().toLowerCase(), start);
          this.leerenZeigen();
          this.zeigen();
        } else {
          this.zeigeStart();
        }
      }
    }

    bauen() {
      const t = this.t;
      const ebene = this.modus === 'ebene';
      const kopf =
        this.modus === 'kollektion'
          ? ''
          : `<div class="cb-s__kopf-band"><div class="cb-s__kopf">` +
            (ebene ? `<button type="button" class="cb-s__zu" data-aktion="schliessen" aria-label="${esc(t.schliessen)}">${ICON.zurueck}</button>` : '') +
            `<form class="cb-s__form" role="search" action="${esc(this.basis)}search" method="get" novalidate>` +
            `<label class="cb-s__feld"><span class="cb-s__sr">${esc(t.suchen)}</span>` +
            `<input class="cb-s__eingabe" type="search" name="q" placeholder="${esc(t.platzhalter)}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" maxlength="80"></label>` +
            `<input type="hidden" name="type" value="product">` +
            `<button type="button" class="cb-s__leeren" data-aktion="leeren" aria-label="${esc(t.leeren)}" hidden>${ICON.x}</button>` +
            `<button type="submit" class="cb-s__los" aria-label="${esc(t.suchen)}">${ICON.lupe}</button>` +
            `</form></div></div>`;
      this.root.innerHTML =
        kopf +
        `<div class="cb-s__inhalt"><div class="cb-s__breite">` +
        (this.modus === 'seite' ? `<h1 class="cb-s__sr">${esc(t.seitentitel)}</h1>` : '') +
        `<div class="cb-s__oben"></div><div class="cb-s__leiste" hidden></div><div class="cb-s__aktiv"></div>` +
        `<p class="cb-s__anzahl" aria-live="polite"></p><div class="cb-s__raster"></div><div class="cb-s__unten"></div>` +
        `</div></div>` +
        `<div class="cb-s__schleier" data-aktion="blatt-zu" hidden></div>` +
        `<div class="cb-s__blatt" role="dialog" aria-modal="true" aria-label="${esc(t.filter)}" hidden></div>`;
      const $ = (s) => this.root.querySelector(s);
      this.eingabe = $('.cb-s__eingabe');
      this.leerenKnopf = $('.cb-s__leeren');
      this.form = $('.cb-s__form');
      this.inhalt = $('.cb-s__inhalt');
      this.oben = $('.cb-s__oben');
      this.leiste = $('.cb-s__leiste');
      this.aktivEl = $('.cb-s__aktiv');
      this.anzahl = $('.cb-s__anzahl');
      this.raster = $('.cb-s__raster');
      this.unten = $('.cb-s__unten');
      this.schleier = $('.cb-s__schleier');
      this.blatt = $('.cb-s__blatt');
    }

    binden() {
      if (this.eingabe && this.form) {
        this.eingabe.addEventListener('input', () => {
          this.leerenZeigen();
          clearTimeout(this.timer);
          const q = this.eingabe.value.trim();
          if (!q) {
            this.zeigeStart();
            return;
          }
          if (q.length < 2) return;
          this.timer = setTimeout(() => this.suchen(q), 320);
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          clearTimeout(this.timer);
          const q = this.eingabe.value.trim();
          if (q) this.suchen(q);
          this.eingabe.blur();
        });
      }
      this.root.addEventListener('click', (e) => this.klick(e));
      this.root.addEventListener('change', (e) => this.aenderung(e));
      this.root.addEventListener('input', (e) => {
        if (e.target.classList.contains('cb-s__katsuche')) {
          this.katSuche = e.target.value;
          this.katFiltern();
        }
      });
      this.root.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.blattOffen) {
          e.stopPropagation();
          this.blattZu();
        } else if (this.modus === 'ebene') {
          e.stopPropagation();
          this.schliessen();
        }
      });
    }

    leerenZeigen() {
      if (this.leerenKnopf && this.eingabe) this.leerenKnopf.hidden = !this.eingabe.value;
    }

    klick(e) {
      const el = e.target.closest('[data-aktion]');
      if (!el || !this.root.contains(el)) return;
      switch (el.dataset.aktion) {
        case 'schliessen':
          this.schliessen();
          break;
        case 'leeren':
          this.eingabe.value = '';
          this.leerenZeigen();
          this.zeigeStart();
          this.eingabe.focus();
          break;
        case 'filter':
          this.blattAuf();
          break;
        case 'blatt-zu':
          this.blattZu();
          break;
        case 'zuruecksetzen':
        case 'alle-filter-weg':
          this.f = neuerFilter();
          this.limit = this.schritt;
          this.stabil = null;
          this.setUrl();
          this.zeigen();
          break;
        case 'set':
          this.f.set = this.f.set === (el.dataset.wert || '') ? '' : el.dataset.wert || '';
          this.limit = this.schritt;
          this.stabil = null;
          this.setUrl();
          this.zeigen();
          break;
        case 'filter-weg':
          this.filterWeg(el.dataset.art, el.dataset.wert);
          break;
        case 'mehr':
          this.limit += this.schritt;
          this.zeigen();
          break;
        case 'muster':
          e.preventDefault();
          this.musterWahl(el);
          break;
        case 'muster-alle':
          e.preventDefault();
          this.offeneFarben[el.dataset.gruppe] = true;
          this.karteNeu(el.dataset.gruppe, null);
          break;
        case 'erneut':
          this.cache.delete(this.q.toLowerCase());
          this.suchen(this.q);
          break;
        default:
      }
    }

    aenderung(e) {
      const el = e.target;
      if (el.matches('select[data-aktion="sort"]')) {
        this.sort = el.value;
        this.limit = this.schritt;
        this.stabil = null;
        this.zeigen();
        this.nachOben();
        return;
      }
      const art = el.dataset.art;
      if (!art) return;
      if (art === 'marke' || art === 'kat') {
        if (el.checked) this.f[art].add(el.value);
        else this.f[art].delete(el.value);
      } else if (art === 'lager') {
        this.f.lager = el.checked;
      } else if (art === 'von' || art === 'bis') {
        const v = parseFloat(el.value);
        this.f[art] = el.value === '' || Number.isNaN(v) ? null : Math.max(0, Math.round(v));
      }
      this.limit = this.schritt;
      this.stabil = null;
      this.zeigen();
    }

    filterWeg(art, wert) {
      if (art === 'marke' || art === 'kat') this.f[art].delete(wert);
      else if (art === 'lager') this.f.lager = false;
      else if (art === 'set') {
        this.f.set = '';
        this.setUrl();
      } else if (art === 'preis') {
        this.f.von = null;
        this.f.bis = null;
      }
      this.limit = this.schritt;
      this.stabil = null;
      this.zeigen();
    }

    nachOben() {
      if (this.modus === 'ebene') {
        this.inhalt.scrollTop = 0;
        return;
      }
      const y = this.root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0);
      if (window.scrollY > y) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    laden(q) {
      const key = q.toLowerCase();
      if (this.cache.has(key)) return Promise.resolve(this.cache.get(key));
      if (this.ctrl) this.ctrl.abort();
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      this.ctrl = ctrl;
      const url = `${this.basis}search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&section_id=cb-suche-daten`;
      return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.text();
        })
        .then((html) => {
          const d = lesen(html);
          this.cache.set(key, d);
          return d;
        });
    }

    suchen(q) {
      this.q = q;
      this.status(true);
      this.laden(q)
        .then((d) => {
          if (this.q !== q) return;
          this.daten = d;
          this.f = neuerFilter();
          this.limit = this.schritt;
          this.wahl = {};
          this.offeneFarben = {};
          this.status(false);
          this.zeigen();
          this.nachOben();
          if (this.modus === 'seite') this.urlSetzen(q);
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          if (this.q !== q) return;
          this.status(false);
          this.fehlerZeigen();
        });
    }

    status(laedt) {
      this.root.classList.toggle('is-laedt', laedt);
      if (laedt) {
        this.anzahl.textContent = this.t.laedt;
        if (!this.raster.children.length) this.raster.innerHTML = this.skelett(4);
      }
    }

    urlSetzen(q) {
      try {
        history.replaceState(history.state, '', `${this.basis}search?q=${encodeURIComponent(q)}&type=product`);
      } catch (e) {
        /* egal */
      }
    }

    fehlerZeigen() {
      const t = this.t;
      this.leiste.hidden = true;
      this.aktivEl.innerHTML = '';
      this.oben.innerHTML = '';
      this.anzahl.textContent = '';
      this.raster.innerHTML = `<div class="cb-s__leer"><p>${esc(t.fehler)}</p><button type="button" class="cb-s__knopf" data-aktion="erneut">${esc(t.erneut)}</button></div>`;
      this.unten.innerHTML = '';
    }

    skelett(n) {
      return Array.from({ length: n }, () => '<div class="cb-s__karte cb-s__karte--skelett" aria-hidden="true"><div class="cb-s__bild"></div><div class="cb-s__s1"></div><div class="cb-s__s2"></div></div>').join('');
    }

    // Ansicht ohne Suchbegriff: beliebte Kategorien und Highlights
    zeigeStart() {
      clearTimeout(this.timer);
      if (this.ctrl) this.ctrl.abort();
      this.q = '';
      this.daten = null;
      this.root.classList.remove('is-laedt');
      this.leiste.hidden = true;
      this.aktivEl.innerHTML = '';
      this.anzahl.textContent = '';
      this.unten.innerHTML = '';
      if (this.startDaten) {
        this.startZeigen('');
        return;
      }
      this.oben.innerHTML = '';
      this.raster.innerHTML = this.skelett(4);
      this.startLaden()
        .then(() => {
          if (!this.q) this.startZeigen('');
        })
        .catch(() => {
          if (!this.q) this.raster.innerHTML = '';
        });
    }

    startLaden() {
      if (this.startDaten) return Promise.resolve(this.startDaten);
      if (!this.startPromise) {
        const url = this.highlights ? `${this.basis}collections/${encodeURIComponent(this.highlights)}?section_id=cb-suche-daten` : `${this.basis}search?section_id=cb-suche-daten`;
        this.startPromise = fetch(url, { credentials: 'same-origin' })
          .then((r) => {
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            return r.text();
          })
          .then((html) => {
            this.startDaten = lesen(html);
            return this.startDaten;
          })
          .catch((e) => {
            this.startPromise = null;
            throw e;
          });
      }
      return this.startPromise;
    }

    startZeigen(vorspann) {
      const t = this.t;
      const d = this.startDaten;
      const kat = d.kat || {};
      const chips = Object.keys(kat)
        .filter((h) => kat[h].e === 1)
        .slice(0, 12)
        .map((h) => kat[h]);
      this.oben.innerHTML =
        (vorspann || '') +
        (chips.length ? `<p class="cb-s__titel-klein">${esc(t.beliebteKat)}</p>${this.chipsHtml(chips)}` : '') +
        (d.p.length ? `<h2 class="cb-s__h2">${esc(t.highlights)}</h2>` : '');
      const gruppen = gruppieren(d.p, this.wahl).slice(0, 8);
      this.gruppenMap = {};
      gruppen.forEach((g) => {
        this.gruppenMap[g.key] = g;
      });
      this.raster.innerHTML = gruppen.map((g) => this.karte(g)).join('');
      this.unten.innerHTML = this.highlights && d.p.length ? `<a class="cb-s__mehr" href="${esc(`${this.basis}collections/${this.highlights}`)}">${esc(t.alleHighlights)}</a>` : '';
    }

    keineTreffer() {
      const t = this.t;
      this.leiste.hidden = true;
      this.aktivEl.innerHTML = '';
      this.anzahl.textContent = '';
      this.unten.innerHTML = '';
      const hinweis = `<div class="cb-s__leer"><p class="cb-s__leer-titel">${esc(fmt(t.keine, { q: this.q }))}</p><p>${esc(t.keineTipp)}</p></div>`;
      this.oben.innerHTML = hinweis;
      this.raster.innerHTML = '';
      const q = this.q;
      this.startLaden()
        .then(() => {
          if (this.q === q && this.daten && !this.daten.p.length) this.startZeigen(hinweis);
        })
        .catch(() => {});
    }

    zeigen() {
      const d = this.daten;
      if (!d) return;
      const t = this.t;
      const kol = this.modus === 'kollektion';
      if (!d.p.length) {
        if (!kol) {
          this.keineTreffer();
          return;
        }
        // Kategorie: Daten kommen noch (Skelett) oder sie ist leer
        this.leiste.hidden = true;
        this.aktivEl.innerHTML = '';
        this.oben.innerHTML = '';
        this.anzahl.textContent = '';
        this.unten.innerHTML = '';
        this.angezeigt = [];
        this.raster.innerHTML = this.laedtNoch
          ? this.skelett(8)
          : `<div class="cb-s__leer"><p>${esc(t.leerKat)}</p><a class="cb-s__knopf-rand" href="${esc(this.basis)}search" data-cb-suche-oeffnen>${esc(t.zurSuche)}</a></div>`;
        return;
      }
      if (kol) {
        this.oben.innerHTML = this.setKacheln();
      } else {
        const chips = this.passendeKategorien(gruppieren(d.p, null));
        this.oben.innerHTML = chips.length ? `<p class="cb-s__titel-klein">${esc(t.passendeKat)}</p>${this.chipsHtml(chips)}` : '';
      }
      this.leisteZeigen();
      const gruppen = this.sortieren(this.nurLager(gruppieren(this.filtern(d.p, null), this.wahl)));
      this.gruppenMap = {};
      gruppen.forEach((g) => {
        this.gruppenMap[g.key] = g;
      });
      this.aktivChips();
      const n = gruppen.length;
      if (kol) this.anzahl.textContent = n === 1 ? t.produkt1 : fmt(t.produktN, { n });
      else this.anzahl.textContent = n === 1 ? t.anzahl1 : fmt(t.anzahlN, { n });
      if (!n) {
        this.raster.innerHTML = `<div class="cb-s__leer"><p>${esc(t.keineFilter)}</p><button type="button" class="cb-s__knopf-rand" data-aktion="alle-filter-weg">${esc(t.filterLoeschen)}</button></div>`;
        this.unten.innerHTML = '';
        this.angezeigt = [];
      } else {
        const sichtbar = gruppen.slice(0, this.limit);
        this.raster.innerHTML = sichtbar.map((g) => this.karte(g)).join('');
        this.angezeigt = sichtbar.map((g) => g.key);
        const rest = n - this.limit;
        this.unten.innerHTML =
          (rest > 0 ? `<button type="button" class="cb-s__mehr" data-aktion="mehr">${esc(t.mehr)} (${rest})</button>` : '') +
          (!kol && d.n > d.p.length ? `<p class="cb-s__hinweis">${esc(t.mehrAls)}</p>` : '');
      }
      // Kategorie lädt noch weitere Seiten: sichtbare Karten bleiben danach an ihrem Platz
      if (kol && this.laedtNoch && d.seite === 1 && this.sort === 'empfohlen' && !this.filterAnzahl()) this.stabil = this.angezeigt.slice();
      if (this.blattOffen) this.blattBauen();
    }

    // «Nur an Lager» für Einzelkarten: zählt die eigene Farbe (die übrigen Karten sind schon über die Produkte gefiltert)
    nurLager(gruppen, ausser) {
      return this.f.lager && ausser !== 'lager' ? gruppen.filter(kartenLager) : gruppen;
    }

    filtern(liste, ausser) {
      const f = this.f;
      return liste.filter((p) => {
        if (ausser !== 'marke' && f.marke.size && !f.marke.has(p._marke || '')) return false;
        if (ausser !== 'kat' && f.kat.size) {
          const ks = (p.k || '').split('|');
          if (!ks.some((k) => k && f.kat.has(k))) return false;
        }
        if (ausser !== 'lager' && f.lager && !lagerP(p)) return false;
        if (ausser !== 'set' && f.set && !setHat(p, f.set)) return false;
        if (ausser !== 'preis') {
          if (f.von != null && Math.max(p.p, p.pm || 0) < f.von * 100) return false;
          if (f.bis != null && Math.min(p.p, p.pm || p.p) > f.bis * 100) return false;
        }
        return true;
      });
    }

    sortieren(gruppen) {
      // sortiert nach dem angezeigten Preis: Aktionspreis, sonst «ab»-Preis, sonst Preis
      const preis = (g) => {
        const s = this.stand(g);
        return !(s.c > s.pr) && s.ab && s.pm ? s.pm : s.pr;
      };
      const name = (g) => `${g.marke} ${g.modell}`;
      // 0 = mindestens eine Farbe an Lager, 1 = bestellbar (Vorbestellung), 2 = ausverkauft
      const stufeLager = (g) => (kartenLager(g) ? 0 : kartenKaufbar(g) ? 1 : 2);
      // Kategorie (03.11.2026): bei jeder Sortierung zuerst an Lager, dann bestellbar, dann ausverkauft
      const lz = this.modus === 'kollektion' && this.lagerZuerst ? stufeLager : () => 0;
      let arr = gruppen.slice();
      switch (this.sort) {
        case 'empfohlen': {
          // Kategorie: Reihenfolge der Kategorie, auf Wunsch zuerst an Lager, dann bestellbar, dann ausverkauft
          if (this.lagerZuerst) arr.sort((a, b) => stufeLager(a) - stufeLager(b) || a.rang - b.rang);
          else arr.sort((a, b) => a.rang - b.rang);
          if (this.stabil && this.stabil.length) {
            const pos = new Map(this.stabil.map((k, i) => [k, i]));
            const vorne = arr.filter((g) => pos.has(g.key)).sort((a, b) => pos.get(a.key) - pos.get(b.key));
            arr = vorne.concat(arr.filter((g) => !pos.has(g.key)));
          }
          break;
        }
        case 'preis-auf':
          arr.sort((a, b) => lz(a) - lz(b) || preis(a) - preis(b) || a.rang - b.rang);
          break;
        case 'preis-ab':
          arr.sort((a, b) => lz(a) - lz(b) || preis(b) - preis(a) || a.rang - b.rang);
          break;
        case 'name-az':
          arr.sort((a, b) => lz(a) - lz(b) || name(a).localeCompare(name(b), this.sprache, { sensitivity: 'base' }));
          break;
        case 'name-za':
          arr.sort((a, b) => lz(a) - lz(b) || name(b).localeCompare(name(a), this.sprache, { sensitivity: 'base' }));
          break;
        default: {
          // Relevanz: zuerst Karten mit dem Suchwort im Titel, darin zuerst an Lager, dann bestellbar, dann ausverkauft
          const passt = titelPasst(this.q);
          const stufe = new Map();
          arr.forEach((g) => {
            stufe.set(g, (kartenTeile(g).some(passt) ? 0 : 3) + stufeLager(g));
          });
          arr.sort((a, b) => stufe.get(a) - stufe.get(b) || a.rang - b.rang);
        }
      }
      return arr;
    }

    // Passende Kategorien: Name enthält das Suchwort (z. B. «Matratzen») zuerst, sonst Treffer² / Produkte der
    // Kategorie (genaue vor grossen). Gezählt werden Produkte mit dem Suchwort im Titel (sonst alle Treffer).
    passendeKategorien(gruppen) {
      const kat = this.daten.kat || {};
      const woerter = norm(this.q || '').split(' ').filter((w) => w.length > 2);
      const imTitel = (p) => {
        const t = norm(p.t);
        return woerter.every((w) => t.includes(w));
      };
      const zaehlen = (nurTitel) => {
        const karten = {};
        const produkte = {};
        gruppen.forEach((g) => {
          const gesehen = {};
          kartenTeile(g).forEach((p) => {
            if (nurTitel && !imTitel(p)) return;
            (p.k || '').split('|').forEach((h) => {
              if (!h || !kat[h]) return;
              produkte[h] = (produkte[h] || 0) + 1;
              if (gesehen[h]) return;
              gesehen[h] = 1;
              karten[h] = (karten[h] || 0) + 1;
            });
          });
        });
        return { karten, produkte };
      };
      let z = woerter.length ? zaehlen(true) : null;
      if (!z || !Object.keys(z.karten).length) z = zaehlen(false);
      const { karten, produkte } = z;
      const name = (h) => woerter.some((w) => norm(kat[h].t).includes(w));
      const wert = (h) => ((produkte[h] * produkte[h]) / Math.max(kat[h].g || 0, produkte[h], 1)) * (name(h) ? 10 : 1);
      const alle = Object.keys(karten);
      const mehrere = alle.filter((h) => karten[h] >= 2 || name(h));
      return (mehrere.length >= 3 ? mehrere : alle)
        .sort((a, b) => wert(b) - wert(a) || kat[b].e - kat[a].e)
        .slice(0, 8)
        .map((h) => kat[h]);
    }

    chipsHtml(liste) {
      return `<div class="cb-s__chips">${liste.map((k) => `<a class="cb-s__chip" href="${esc(k.u)}">${esc(k.t)}</a>`).join('')}</div>`;
    }

    leisteZeigen() {
      const t = this.t;
      this.leiste.hidden = false;
      if (!this.leisteGebaut) {
        this.leiste.innerHTML =
          `<button type="button" class="cb-s__filterknopf" data-aktion="filter" aria-haspopup="dialog"><span>${esc(t.filter)}<span class="cb-s__filterzahl"></span></span>${ICON.filter}</button>` +
          `<label class="cb-s__sortwahl"><span class="cb-s__sr">${esc(t.sortieren)}</span><select data-aktion="sort">` +
          this.sortListe.map((k) => `<option value="${k}">${esc(t.sort[k])}</option>`).join('') +
          `</select>${ICON.runter}</label>`;
        this.leisteGebaut = true;
      }
      this.leiste.querySelector('select').value = this.sort;
      const n = this.filterAnzahl();
      this.leiste.querySelector('.cb-s__filterzahl').textContent = n ? ` (${n})` : '';
    }

    filterAnzahl() {
      const f = this.f;
      return f.marke.size + f.kat.size + (f.lager ? 1 : 0) + (f.von != null || f.bis != null ? 1 : 0) + (f.set ? 1 : 0);
    }

    aktivChips() {
      const f = this.f;
      const t = this.t;
      const kat = this.daten.kat || {};
      const chip = (art, wert, label) =>
        `<button type="button" class="cb-s__aktiv-chip" data-aktion="filter-weg" data-art="${art}" data-wert="${esc(wert)}" aria-label="${esc(fmt(t.entfernen, { x: label }))}">${esc(label)}${ICON.xKlein}</button>`;
      let html = '';
      f.marke.forEach((v) => {
        html += chip('marke', v, v);
      });
      f.kat.forEach((h) => {
        html += chip('kat', h, (kat[h] || {}).t || h);
      });
      if (f.set) html += chip('set', f.set, t.setTypen[f.set] || f.set);
      if (f.lager) html += chip('lager', '1', t.nurLager);
      if (f.von != null || f.bis != null) html += chip('preis', '1', `CHF ${f.von != null ? f.von : 0} – ${f.bis != null ? f.bis : '…'}`);
      if (html) html += `<button type="button" class="cb-s__alle-weg" data-aktion="alle-filter-weg">${esc(t.filterLoeschen)}</button>`;
      this.aktivEl.innerHTML = html;
    }

    // Werte einer Filtergruppe mit Anzahl Karten (berechnet mit allen anderen aktiven Filtern)
    facette(art) {
      const d = this.daten;
      const kat = d.kat || {};
      const basis = this.nurLager(gruppieren(this.filtern(d.p, art), null), art);
      if (art === 'lager') return basis.filter(kartenLager).length;
      const zaehler = {};
      basis.forEach((g) => {
        const gesehen = {};
        kartenTeile(g).forEach((p) => {
          const werte = art === 'marke' ? [p._marke || ''] : (p.k || '').split('|');
          werte.forEach((w) => {
            if (!w || gesehen[w] || (art === 'kat' && !kat[w])) return;
            gesehen[w] = 1;
            zaehler[w] = (zaehler[w] || 0) + 1;
          });
        });
      });
      const aktiv = this.f[art];
      aktiv.forEach((w) => {
        if (!(w in zaehler)) zaehler[w] = 0;
      });
      let liste = Object.keys(zaehler).map((w) => ({
        wert: w,
        label: art === 'marke' ? w : (kat[w] || {}).t || w,
        n: zaehler[w],
        an: aktiv.has(w),
        eltern: art === 'kat' && kat[w] && kat[w].o && kat[kat[w].o] ? kat[kat[w].o].t : '',
      }));
      if (art === 'kat' && this.modus === 'kollektion') {
        // Auf einer Kategorieseite: die Kategorie selbst und Kategorien, in denen alle Produkte sind, helfen nicht
        const ab = this.abdeckung();
        liste = liste.filter((x) => x.an || (x.wert !== this.kollektion && (ab.n[x.wert] || 0) < ab.gesamt));
      }
      if (art === 'kat') {
        const anz = {};
        liste.forEach((x) => {
          anz[x.label] = (anz[x.label] || 0) + 1;
        });
        liste.forEach((x) => {
          x.zusatz = anz[x.label] > 1 ? x.eltern : '';
        });
      }
      return liste.sort((a, b) => b.n - a.n || a.label.localeCompare(b.label, this.sprache, { sensitivity: 'base' }));
    }

    ergebnisAnzahl() {
      return this.nurLager(gruppieren(this.filtern(this.daten.p, null), null)).length;
    }

    // Wie viele Karten (ohne Filter) zu jeder Kategorie gehören – einmal je Datenstand berechnet
    abdeckung() {
      if (this.ab && this.ab.v === this.datenVersion) return this.ab;
      const gruppen = gruppieren(this.daten.p, null);
      const n = {};
      gruppen.forEach((g) => {
        const gesehen = {};
        kartenTeile(g).forEach((p) => {
          (p.k || '').split('|').forEach((h) => {
            if (!h || gesehen[h]) return;
            gesehen[h] = 1;
            n[h] = (n[h] || 0) + 1;
          });
        });
      });
      this.ab = { v: this.datenVersion, n, gesamt: gruppen.length };
      return this.ab;
    }

    blattBauen() {
      if (!this.daten) return;
      const t = this.t;
      const f = this.f;
      const alt = this.blatt.querySelector('.cb-s__blatt-koerper');
      const scroll = alt ? alt.scrollTop : 0;
      const zu = {};
      this.blatt.querySelectorAll('details[data-teil]').forEach((dt) => {
        if (!dt.open) zu[dt.dataset.teil] = true;
      });
      const marken = this.facette('marke');
      const kats = this.facette('kat');
      const lagerN = this.facette('lager');
      const preise = this.daten.p.map((p) => p.p).filter((x) => x > 0);
      const min = preise.length ? Math.floor(Math.min(...preise) / 100) : 0;
      const max = preise.length ? Math.ceil(Math.max(...preise) / 100) : 0;
      const abschnitt = (teil, titel, inhalt) =>
        `<details class="cb-s__abschnitt" data-teil="${teil}"${zu[teil] ? '' : ' open'}><summary>${esc(titel)}${ICON.runter}</summary><div class="cb-s__abschnitt-inhalt">${inhalt}</div></details>`;
      const liste = (art, werte) =>
        `<div class="cb-s__wahlliste">${werte
          .map(
            (w) =>
              `<label class="cb-s__wahl${w.n ? '' : ' is-leer'}" data-such="${esc(`${w.label} ${w.zusatz || ''}`.toLowerCase())}"><input type="checkbox" data-art="${art}" value="${esc(w.wert)}"${w.an ? ' checked' : ''}><span>${esc(w.label)}${w.zusatz ? ` <small>· ${esc(w.zusatz)}</small>` : ''}</span><span class="cb-s__wahl-n">${w.n}</span></label>`,
          )
          .join('')}</div>`;
      let koerper = '';
      if (marken.length) koerper += abschnitt('marke', t.marke, liste('marke', marken));
      if (kats.length) koerper += abschnitt('kat', t.kategorie, (kats.length > 8 ? `<input type="search" class="cb-s__katsuche" placeholder="${esc(t.katSuchen)}" value="${esc(this.katSuche)}" aria-label="${esc(t.katSuchen)}">` : '') + liste('kat', kats));
      koerper += abschnitt(
        'lager',
        t.verfuegbarkeit,
        `<label class="cb-s__wahl${lagerN ? '' : ' is-leer'}"><input type="checkbox" data-art="lager" value="1"${f.lager ? ' checked' : ''}><span>${esc(t.nurLager)}</span><span class="cb-s__wahl-n">${lagerN}</span></label>`,
      );
      koerper += abschnitt(
        'preis',
        t.preis,
        `<div class="cb-s__preis-felder"><label><span>${esc(t.von)}</span><input type="number" inputmode="numeric" min="0" step="1" data-art="von" placeholder="${min}" value="${f.von != null ? f.von : ''}"></label>` +
          `<label><span>${esc(t.bis)}</span><input type="number" inputmode="numeric" min="0" step="1" data-art="bis" placeholder="${max}" value="${f.bis != null ? f.bis : ''}"></label></div>`,
      );
      this.blatt.innerHTML =
        `<div class="cb-s__blatt-kopf"><p class="cb-s__blatt-titel">${esc(t.filter)}</p><div class="cb-s__blatt-aktionen">` +
        (this.filterAnzahl() ? `<button type="button" class="cb-s__textknopf" data-aktion="zuruecksetzen">${esc(t.zuruecksetzen)}</button>` : '') +
        `<button type="button" class="cb-s__zu-x" data-aktion="blatt-zu" aria-label="${esc(t.filterZu)}">${ICON.x}</button></div></div>` +
        `<div class="cb-s__blatt-koerper">${koerper}</div>` +
        `<div class="cb-s__blatt-fuss"><button type="button" class="cb-s__knopf" data-aktion="blatt-zu">${esc(fmt(t.anzeigen, { n: this.ergebnisAnzahl() }))}</button></div>`;
      const neu = this.blatt.querySelector('.cb-s__blatt-koerper');
      if (neu) neu.scrollTop = scroll;
      this.katFiltern();
    }

    katFiltern() {
      const q = (this.katSuche || '').trim().toLowerCase();
      this.blatt.querySelectorAll('details[data-teil="kat"] .cb-s__wahl').forEach((el) => {
        el.classList.toggle('is-versteckt', !!q && !(el.dataset.such || '').includes(q));
      });
    }

    blattAuf() {
      if (!this.daten) return;
      this.blattOffen = true;
      this.blattBauen();
      this.schleier.hidden = false;
      this.blatt.hidden = false;
      if (this.modus !== 'ebene') document.documentElement.classList.add('cb-s-gesperrt');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.root.classList.add('blatt-offen'));
      });
      const zu = this.blatt.querySelector('.cb-s__zu-x');
      if (zu) zu.focus({ preventScroll: true });
    }

    blattZu(still) {
      if (!this.blattOffen) return;
      this.blattOffen = false;
      this.root.classList.remove('blatt-offen');
      if (this.modus !== 'ebene') document.documentElement.classList.remove('cb-s-gesperrt');
      setTimeout(() => {
        if (!this.blattOffen) {
          this.blatt.hidden = true;
          this.schleier.hidden = true;
        }
      }, 260);
      if (!still) {
        const k = this.leiste.querySelector('.cb-s__filterknopf');
        if (k) k.focus({ preventScroll: true });
      }
    }

    logo(p) {
      const marken = (this.daten || this.startDaten || {}).marken || {};
      const hs = (p.m || '').split('|');
      for (const h of hs) {
        const m = marken[h];
        if (m && m.l) return `<img src="${esc(m.l)}" alt="${esc(m.t)}" loading="lazy" height="18">`;
      }
      return '';
    }

    // Was eine Karte zeigt: das gewählte Produkt bzw. die gewählte Farb-Variante (Bild, Preis, Lagerstand, Adresse).
    // Ohne eigene Wahl zeigt ein Produkt mit Varianten sein Hauptbild (z. B. ein Bild im Auto).
    stand(g) {
      const p = g.glieder[g.aktiv] || g.glieder[0];
      let v = null;
      let eigen = false;
      if (g.var) {
        v = g.var[g.vAktiv] || g.var[0];
        eigen = g.vGewaehlt || v.i !== p.vi;
      } else if (!p.l && Array.isArray(p.vs) && p.vs.length > 1) {
        // Mehrere Produkte auf der Karte: ist die gezeigte Variante nicht an Lager, eine andere aber schon, diese zeigen
        v = p.vs.find((x) => x.l) || null;
        eigen = !!v;
      }
      if (!v) return { p, b: p.b, pr: p.p, pm: p.pm, pf: p.pf, ab: p.ab, c: p.c, cf: p.cf, l: !!p.l, w: !!p.w, a: !!p.a, u: p.u };
      return {
        p,
        b: eigen ? v.b || p.b : p.b || v.b,
        pr: v.p,
        pm: v.p,
        pf: v.pf,
        ab: '',
        c: v.c,
        cf: v.cf,
        l: !!v.l,
        w: !!v.w,
        a: !!v.a,
        u: eigen ? mitVariante(p.u, v.i) : p.u,
      };
    }

    karte(g) {
      const t = this.t;
      const s = this.stand(g);
      const p = s.p;
      let badges = '';
      if (s.c > s.pr) badges += `<span class="cb-s__badge cb-s__badge--rabatt">−${Math.round((1 - s.pr / s.c) * 100)} %</span>`;
      if (s.l) badges += `<span class="cb-s__badge cb-s__badge--lager">${esc(t.anLager)}</span>`;
      else if (s.w) badges += `<span class="cb-s__badge cb-s__badge--uhr" role="img" aria-label="${esc(t.vorbestellbar)}" title="${esc(t.vorbestellbar)}">${ICON.uhr}</span>`;
      else if (!s.a) badges += `<span class="cb-s__badge cb-s__badge--aus">${esc(t.ausverkauft)}</span>`;
      const bild = s.b ? `<img src="${esc(s.b)}" srcset="${esc(klein(s.b, 300))} 300w, ${esc(s.b)} 420w" sizes="(max-width: 699px) 46vw, (max-width: 999px) 30vw, 300px" alt="" loading="lazy" width="420" height="420">` : '';
      const logo = this.logo(p);
      // Musterbilder: Farben desselben Modells (eigene Produkte) oder die Farb-Varianten eines Produkts
      const muster = g.var
        ? g.var.map((v, i) => ({ name: v.n || '', b: v.b || p.b, an: i === g.vAktiv }))
        : g.glieder.map((m, i) => ({ name: zerlegen(m).farbe || m.t, b: m.b, an: i === g.aktiv }));
      const aktivIndex = g.var ? g.vAktiv : g.aktiv;
      let farben = '';
      if (muster.length > 1) {
        const alle = this.offeneFarben[g.key];
        const max = window.matchMedia && window.matchMedia('(min-width: 700px)').matches ? 5 : 3;
        let zeigen = muster.map((m, i) => i);
        if (!alle && zeigen.length > max) {
          zeigen = zeigen.slice(0, max);
          if (aktivIndex >= max) zeigen[max - 1] = aktivIndex;
        }
        farben =
          `<div class="cb-s__farben"><span class="cb-s__farben-titel">${esc(t.farbe)}</span><div class="cb-s__muster">` +
          zeigen
            .map((i) => {
              const m = muster[i];
              return `<button type="button" class="cb-s__muster-knopf${m.an ? ' is-aktiv' : ''}" data-aktion="muster" data-gruppe="${esc(g.key)}" data-index="${i}" title="${esc(m.name)}" aria-label="${esc(m.name)}" aria-pressed="${m.an}">${m.b ? `<img src="${esc(klein(m.b, 120))}" alt="" loading="lazy" width="40" height="40">` : `<span>${esc(m.name.slice(0, 2))}</span>`}</button>`;
            })
            .join('') +
          (!alle && muster.length > max ? `<button type="button" class="cb-s__muster-mehr" data-aktion="muster-alle" data-gruppe="${esc(g.key)}" aria-label="${esc(t.alleFarben)}">+${muster.length - max}</button>` : '') +
          `</div></div>`;
      }
      let preis;
      if (s.c > s.pr) preis = `<span class="cb-s__preis-neu">${esc(s.pf)}</span> <span class="cb-s__preis-alt">| ${esc(t.statt)} ${esc(s.cf)}</span>`;
      else if (s.ab) preis = `<span>${esc(t.ab)} ${esc(s.ab)}</span>`;
      else preis = `<span>${esc(s.pf)}</span>`;
      // Einzelkarte je Farb-Variante (Tag «einzeln-muster»): Farbe der gezeigten Variante in den Titel
      const name = zerlegen(p).modell || g.modell;
      const titel = (g.marke ? `<strong>${esc(g.marke.toUpperCase())}</strong> ` : '') + esc(g.eigenV && g.var ? mitFarbe(name, (g.var[g.vAktiv] || {}).n) : name);
      return (
        `<article class="cb-s__karte" data-gruppe="${esc(g.key)}">` +
        `<a class="cb-s__bild" href="${esc(s.u)}" tabindex="-1" aria-hidden="true">${bild}<span class="cb-s__badges">${badges}</span></a>` +
        (logo ? `<div class="cb-s__logo">${logo}</div>` : '') +
        farben +
        `<a class="cb-s__titel" href="${esc(s.u)}">${titel}</a>` +
        `<div class="cb-s__preis">${preis}</div>` +
        `</article>`
      );
    }

    musterWahl(el) {
      const key = el.dataset.gruppe;
      const g = this.gruppenMap[key];
      if (!g) return;
      const i = parseInt(el.dataset.index, 10);
      if (g.var) {
        if (!g.var[i]) return;
        g.vAktiv = i;
        g.vGewaehlt = true;
        this.wahl[`${key}#v`] = g.var[i].i;
      } else {
        if (!g.glieder[i]) return;
        g.aktiv = i;
        this.wahl[key] = g.glieder[i].i;
      }
      this.karteNeu(key, i);
    }

    karteNeu(key, fokusIndex) {
      const g = this.gruppenMap[key];
      if (!g) return;
      const alt = Array.from(this.raster.querySelectorAll('.cb-s__karte')).find((k) => k.dataset.gruppe === key);
      if (!alt) return;
      const huelle = document.createElement('div');
      huelle.innerHTML = this.karte(g);
      const neu = huelle.firstElementChild;
      alt.replaceWith(neu);
      if (fokusIndex != null) {
        const k = neu.querySelector(`.cb-s__muster-knopf[data-index="${fokusIndex}"]`);
        if (k) k.focus({ preventScroll: true });
      }
    }

    // Kategorieseite: Zustand nach «Zurück» wiederherstellen, Karten zeigen, weitere Seiten nachladen
    kollektionStarten() {
      const z = this.zustandLesen();
      if (z) {
        const f = z.f || {};
        if (this.sortListe.indexOf(z.sort) >= 0) this.sort = z.sort;
        this.f = {
          marke: new Set(Array.isArray(f.marke) ? f.marke : []),
          kat: new Set(Array.isArray(f.kat) ? f.kat : []),
          lager: !!f.lager,
          von: typeof f.von === 'number' ? f.von : null,
          bis: typeof f.bis === 'number' ? f.bis : null,
          set: typeof f.set === 'string' && SET_TYPEN.indexOf(f.set) >= 0 ? f.set : '',
        };
        this.limit = Math.max(this.schritt, parseInt(z.limit, 10) || this.schritt);
        this.wahl = z.wahl && typeof z.wahl === 'object' ? z.wahl : {};
        this.offeneFarben = z.offen && typeof z.offen === 'object' ? z.offen : {};
        this.stabil = Array.isArray(z.stabil) && z.stabil.length ? z.stabil : null;
        this.zielY = typeof z.y === 'number' ? z.y : null;
      }
      try {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      } catch (e) {
        /* egal */
      }
      try {
        const s = new URLSearchParams(location.search).get('set');
        if (s && SET_TYPEN.indexOf(s) >= 0) this.f.set = s;
      } catch (e) {
        /* egal */
      }
      window.addEventListener('pagehide', () => this.zustandSpeichern());
      this.restLaden();
      this.zeigen();
      this.scrollWiederherstellen();
    }

    seiteHolen(s) {
      const url = `${location.pathname}?section_id=cb-kollektion-daten&page=${s}`;
      return fetch(url, { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.text();
        })
        .then((html) => ({ s, d: lesen(html) }))
        .catch(() => ({ s, d: null }));
    }

    // Kategorie mit mehr als 250 Produkten (bzw. ohne Daten in der Seite): übrige Seiten laden und anhängen
    restLaden() {
      const d = this.daten;
      if (!this.kollektion || !d) return;
      if (!d.seite) {
        this.laedtNoch = true;
        this.seiteHolen(1).then((x) => {
          this.laedtNoch = false;
          if (x.d) {
            this.daten = x.d;
            this.datenVersion += 1;
            this.restLaden();
          }
          this.zeigen();
          this.scrollWiederherstellen();
        });
        return;
      }
      const gr = d.gr || 250;
      const seiten = Math.min(40, Math.ceil((d.n || 0) / gr));
      const hier = d.seite;
      const fehlen = [];
      for (let s = 1; s <= seiten; s += 1) if (s !== hier) fehlen.push(s);
      if (!fehlen.length) return;
      this.laedtNoch = true;
      Promise.all(fehlen.map((s) => this.seiteHolen(s))).then((teile) => {
        const je = {};
        je[hier] = d.p;
        teile.forEach((x) => {
          if (x.d) je[x.s] = x.d.p;
        });
        const gesehen = new Set();
        const alle = [];
        for (let s = 1; s <= seiten; s += 1) {
          (je[s] || []).forEach((p) => {
            if (gesehen.has(p.i)) return;
            gesehen.add(p.i);
            alle.push(p);
          });
        }
        alle.forEach((p, i) => {
          p._rang = i;
        });
        d.p = alle;
        d.seite = 1;
        this.datenVersion += 1;
        this.laedtNoch = false;
        this.zeigen();
        this.scrollWiederherstellen();
      });
    }

    // Gewählten Set-Typ in der Adresse festhalten (?set=4in1), damit die Ansicht geteilt und verlinkt werden kann
    setUrl() {
      if (this.modus !== 'kollektion') return;
      try {
        const u = new URL(location.href);
        if (this.f.set) u.searchParams.set('set', this.f.set);
        else u.searchParams.delete('set');
        history.replaceState(history.state, '', `${u.pathname}${u.search}${u.hash}`);
      } catch (e) {
        /* egal */
      }
    }

    // Set-Typ-Kacheln: «Alle» + je vorhandenem Set-Typ eine Kachel mit Bild (zuerst ein lagerndes Produkt) und Anzahl Karten.
    // Gezählt mit allen anderen aktiven Filtern. Erst ab zwei Set-Typen (oder wenn einer gewählt ist).
    setKacheln() {
      // Nur auf Modellseiten u. ä. (z. B. «Nuna MIXX next»): nicht auf den Set-Typ-Seiten, nicht auf Kategorien der Ebenen 1/2
      // (dort führt die Bildleiste «Unterkategorien» weiter) und nicht auf Markenseiten
      const d = this.daten;
      if (this.modus !== 'kollektion' || SET_OHNE.has(this.kollektion) || (d.kat || {})[this.kollektion] || (d.marken || {})[this.kollektion]) return '';
      const t = this.t;
      const basis = this.filtern(d.p, 'set');
      const bildVon = (liste) => {
        const p = liste.slice().sort((a, b) => (lagerP(a) ? 0 : kaufbarP(a) ? 1 : 2) - (lagerP(b) ? 0 : kaufbarP(b) ? 1 : 2) || (a._rang || 0) - (b._rang || 0)).find((x) => x.b);
        return p ? p.b : '';
      };
      const typen = SET_TYPEN.map((s) => {
        const liste = basis.filter((p) => setHat(p, s));
        return liste.length ? { s, n: this.nurLager(gruppieren(liste, null)).length, b: bildVon(liste) } : null;
      }).filter(Boolean);
      if (typen.length < 2 && !this.f.set) return '';
      const kachel = (s, label, n, b) => {
        const an = (this.f.set || '') === s;
        return (
          `<li><button type="button" class="cb-s__set-karte${an ? ' is-aktiv' : ''}" data-aktion="set" data-wert="${esc(s)}" aria-pressed="${an}">` +
          `<span class="cb-s__set-bild">${b ? `<img src="${esc(klein(b, 240))}" alt="" loading="lazy" width="240" height="240">` : ''}</span>` +
          `<span class="cb-s__set-name">${esc(label)}</span>` +
          `<span class="cb-s__set-zahl">${esc(n === 1 ? t.produkt1 : fmt(t.produktN, { n }))}</span></button></li>`
        );
      };
      return (
        `<nav class="cb-s__sets" aria-label="${esc(t.setTitel)}"><ul class="cb-s__set-liste">` +
        kachel('', t.setTypen.alle, this.nurLager(gruppieren(basis, null)).length, bildVon(basis)) +
        typen.map((x) => kachel(x.s, t.setTypen[x.s] || x.s, x.n, x.b)).join('') +
        `</ul></nav>`
      );
    }

    zustandKey() {
      return `cb-kategorie:${this.sprache}:${location.pathname}`;
    }

    zustandLesen() {
      let z = null;
      try {
        const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
        const zurueck = nav ? nav.type === 'back_forward' : !!(performance.navigation && performance.navigation.type === 2);
        if (!zurueck) return null;
        z = JSON.parse(sessionStorage.getItem(this.zustandKey()) || 'null');
      } catch (e) {
        return null;
      }
      if (!z || Date.now() - (z.z || 0) > 30 * 60 * 1000) return null;
      return z;
    }

    zustandSpeichern() {
      try {
        sessionStorage.setItem(
          this.zustandKey(),
          JSON.stringify({
            z: Date.now(),
            y: window.scrollY || window.pageYOffset || 0,
            limit: this.limit,
            sort: this.sort,
            f: { marke: Array.from(this.f.marke), kat: Array.from(this.f.kat), lager: this.f.lager, von: this.f.von, bis: this.f.bis, set: this.f.set },
            wahl: this.wahl,
            offen: this.offeneFarben,
            stabil: this.sort === 'empfohlen' ? this.angezeigt : [],
          }),
        );
      } catch (e) {
        /* egal */
      }
    }

    scrollWiederherstellen() {
      if (this.zielY == null || this.laedtNoch) return;
      const y = this.zielY;
      this.zielY = null;
      requestAnimationFrame(() => window.scrollTo(0, y));
    }

    // Such-Ebene öffnen und schliessen
    oeffnen(ausloeser) {
      if (this.modus !== 'ebene') return;
      if (this.istOffen) {
        this.eingabe.focus();
        return;
      }
      this.istOffen = true;
      this.ausloeser = ausloeser || document.activeElement;
      this.root.hidden = false;
      document.documentElement.classList.add('cb-s-gesperrt');
      this.eingabe.focus({ preventScroll: true });
      try {
        history.pushState({ cbSuche: true }, '');
        this.verlauf = true;
      } catch (e) {
        this.verlauf = false;
      }
      if (!this.q) this.zeigeStart();
      requestAnimationFrame(() => this.root.classList.add('is-sichtbar'));
    }

    schliessen(vonVerlauf) {
      if (!this.istOffen) return;
      this.istOffen = false;
      this.blattZu(true);
      this.root.classList.remove('is-sichtbar');
      this.root.hidden = true;
      document.documentElement.classList.remove('cb-s-gesperrt');
      if (!vonVerlauf && this.verlauf && history.state && history.state.cbSuche) history.back();
      this.verlauf = false;
      if (this.ausloeser && this.ausloeser.focus) {
        try {
          this.ausloeser.focus({ preventScroll: true });
        } catch (e) {
          /* egal */
        }
      }
    }

    fokus() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.eingabe.focus({ preventScroll: true });
    }
  }

  const init = () => {
    if (API.seite || API.ebene || API.kollektion) return;
    const seiteEl = document.querySelector('[data-cb-suche="seite"]');
    const ebeneEl = document.querySelector('[data-cb-suche="ebene"]');
    const kollektionEl = document.querySelector('[data-cb-suche="kollektion"]');
    if (seiteEl) API.seite = new App(seiteEl, 'seite');
    else if (ebeneEl) API.ebene = new App(ebeneEl, 'ebene');
    if (kollektionEl) API.kollektion = new App(kollektionEl, 'kollektion');
  };

  // Lupe im Kopfbereich, Suchfeld am Handy und andere Such-Links öffnen die Ebene statt der Theme-Suche
  document.addEventListener(
    'click',
    (e) => {
      const a = e.target.closest && e.target.closest('[aria-controls="search-drawer"], [data-cb-suche-oeffnen]');
      if (!a) return;
      if (API.seite) {
        e.preventDefault();
        e.stopImmediatePropagation();
        API.seite.fokus();
        return;
      }
      if (!API.ebene) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      API.ebene.oeffnen(a);
    },
    true,
  );
  window.addEventListener('popstate', () => {
    if (API.ebene && API.ebene.istOffen) API.ebene.schliessen(true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
